<template>
  <div class="inbox-page">
    <h1>{{$t('msg.t901')}}</h1>
    <div class="inbox-page-main">
      <div class="tabswrap">
        <ul>
          <li :class="{ activetab : selectedTab===tabs[0].id  }">
            <button type="button" @click="onSelectTab(tabs[0].filter, tabs[0].id)">
              <span>{{ $t('jgjk.s60') }} </span><span class="tabsnum">{{ tabs[0].sum }}</span>
            </button>
          </li>
          <li :class="{ activetab : selectedTab===tabs[1].id }">
            <button type="button" @click="onSelectTab(tabs[1].filter, tabs[1].id)">
              <span>{{$t('msg.t902')}} </span><span class="tabsnum">{{tabs[1].sum}}</span>
            </button>
          </li>
          <li :class="{ activetab : selectedTab===tabs[2].id }">
            <button type="button" @click="onSelectTab(tabs[2].filter, tabs[2].id)">
              <span>{{$t('msg.t903')}} </span><span class="tabsnum">{{tabs[2].sum}}</span>
            </button>
          </li>
        </ul>
      </div>

      <div class="inbox-table">
        <div class="tablebox">
          <el-table 
            v-loading="tableloading" 
            ref="multipleTable" 
            :data="tableData"
            tooltip-effect="dark" 
            style="width: 100%"
            size="mini"
          >
            <el-table-column type="expand" width="1">
              <template slot-scope="scope">
                <p v-html="scope.row.content"></p>
              </template>
            </el-table-column>

            <el-table-column width="20">
              <template slot-scope="scope">
                <i class="dotread" :class="scope.row.status === 0 ? dotcalss.notread : dotcalss.isread"></i>
              </template>
            </el-table-column>

            <el-table-column :label="$t('szfx.t24')">
              <template slot-scope="scope">
                <p v-html="scope.row.content" @click="expandmsg(scope.row)"></p>
              </template>
            </el-table-column>

            <el-table-column prop='createdAt' :label="$t('jgjk.s17')" width="150"></el-table-column>

          </el-table>          
        </div>


        <div class="pagewrap">
          <el-pagination
            small
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentpage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totals">
          </el-pagination>      
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      selectedTab: 'tab_all',
      totals: 0,
      tabs: [
        {
          id: "tab_all",
          filter: 0,                
          sum: 0,
          isActive: true
        },
        {
          id: "tab_pending",
          filter: 2,
          sum: 0,
        },
        {
          id: "tab_waiting",
          filter: 1,
          sum: 0,
        }
      ],
      tableloading: false,
      tableData: [],
      dotcalss: {
        notread: "notread",
        isread: "isread"
      },
      currentpage: 1,
      msgtype: 0
    }
  },

  mounted(){
    this.getMsgListCount()
    this.getMsgList()
  },

  methods: {
    
    /**
     * Tab选项
     */
    onSelectTab: function(filter,tabid){
      this.selectedTab = tabid
      this.msgtype = filter
      this.currentpage = 1
      this.getMsgList()
    },

    /**
     * 点击消息
     */
    expandmsg: function(row){
      let ntable = this.$refs.multipleTable
      ntable.toggleRowExpansion(row)
      if(row.status/1 === 0){
        this.setMsgIsRead(row.id)
        row.status = 1
      }
    },
    
    /**
     * 分页
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      let that = this
      that.currentpage = val
      that.getMsgList()
    },

    /**
     * 获取消息条目数
     */
    getMsgListCount: function(ref){
      let that = this
      let url = that.API_URL + '/v3/notification/count'
      that.tableloading = true
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(rex) {
          console.log('getMsgList', rex)
          that.tabs[0].sum = rex[0]
          that.tabs[1].sum = rex[2]
          that.tabs[2].sum = rex[1]
        },
        error: function(response) {
          console.log('getMsgList', response)
        }
      })

    },

    /**
     * 获取消息列表
     */
    getMsgList: function(ref){
      let that = this
      let url = that.API_URL + '/v3/notification/list'
      let data = {
        type: that.msgtype,
        page: that.currentpage
      }
      that.tableloading = true
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        data: data,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        success: function(rex) {
          console.log('getMsgList', rex)
          that.totals = rex[0][0].Count
          that.tableData = rex[1].map(function(val){
            return{
              id: val.id,
              content: val.content,
              createdAt: that.$moment(val.createdAt).format('YYYY-MM-DD HH:mm:ss'),
              status: val.status
            }
          })
          that.tableloading = false
        },
        error: function(response) {
          console.log('getMsgList', response)
        }
      })

    },

    /**
     * 设置为已读
     */
    setMsgIsRead: function(mid){
      let that = this
      let url = that.API_URL + '/v3/notification/read'
      let putdata = {
        id : mid,
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: putdata,
        changeOrigin: true,
        success: function(rex) {
          console.log('setMsgIsRead-success',rex)
        },
        error: function(response) {
          console.log('setMsgIsRead-error', response)
        }
      })      
    },

  }
}
</script>
